export default __webpack_public_path__ + "static/char-s-47-zh-Hans-5745ddb3dd7414eb948408d4c2cc9ac1.webp";